// extracted by mini-css-extract-plugin
module.exports = {"powered-wrapper":"AppFooter_powered-wrapper_24n_x","powered-link":"AppFooter_powered-link_1VPFl","powered-logo":"AppFooter_powered-logo_2ErLZ"};